const Flash = {
  broadcast: (type, message) => {
    document.body.dispatchEvent(new CustomEvent("flashBroadcast", {
      detail: { type: type, body: message }
    }));
  }
}

export default Flash
